export default "__VITE_ASSET__C1uAv91C__"